// extracted by mini-css-extract-plugin
module.exports = {"AuthAdvertisingBanner":"AdvertisingBanner_AuthAdvertisingBanner__icPAm"};